export * as Schema from './schema';
export var PartnersCapitalCategory;
(function (PartnersCapitalCategory) {
    PartnersCapitalCategory["ContributionsInsideCommitment"] = "contributionsInsideCommitment";
    PartnersCapitalCategory["ContributionsOutsideOfCommitment"] = "contributionsOutsideOfCommitment";
    PartnersCapitalCategory["RecallableDistributions"] = "recallableDistributions";
    PartnersCapitalCategory["NonRecallableDistributions"] = "nonRecallableDistributions";
})(PartnersCapitalCategory || (PartnersCapitalCategory = {}));
//# sourceMappingURL=index.js.map